import React, { useState } from 'react';
import { Modal, Button, Flex, Input, Select, Form } from 'antd';
import type { SelectProps } from 'antd';
import { PROJECT_TYPES } from '../constants';

interface CreateProjectModalProps {
    open: boolean;
    onClose: () => void;
    onCreate: (name: string, type: number) => Promise<void>;
}

const projectTypeOptions: SelectProps['options'] = [
    { value: PROJECT_TYPES.private, label: 'Приватный' },
    { value: PROJECT_TYPES.public, label: 'Публичный' },
];

const CreateProjectModal: React.FC<CreateProjectModalProps> = ({ open, onClose, onCreate }) => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (values: { name: string; type: number }) => {
        setLoading(true);
        try {
            await onCreate(values.name.trim(), values.type);
            form.resetFields();
            onClose();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Добавление проекта"
            open={open}
            onCancel={onClose}
            footer={null}
            width={600}
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleSubmit}
                initialValues={{ type: PROJECT_TYPES.private }}
            >
                <Form.Item
                    label="Название проекта"
                    name="name"
                    rules={[
                        { required: true, message: 'Введите название проекта' },
                        { max: 60, message: 'Название не должно превышать 60 символов' },
                        {
                            pattern: /^[ a-zа-яё0-9_-]+$/i,
                            message: 'В названии имеются недопустимые символы',
                        },
                        {
                            pattern: /[a-zа-яё0-9]/i,
                            message: 'Название должно содержать хотя бы одну букву или цифру',
                        },
                    ]}
                >
                    <Input 
                        placeholder="Введите название проекта" 
                        count={{
                            show: true,
                            max: 60,
                        }}
                    />
                </Form.Item>

                <Form.Item
                    label="Тип проекта"
                    name="type"
                    rules={[{ required: true, message: 'Выберите тип проекта' }]}
                    help="Приватный проект могут видеть и редактировать только добавленные пользователи. Публичный проект доступен для чтения любому пользователю по ссылке."
                >
                    <Select
                        options={projectTypeOptions}
                        placeholder="Выберите тип проекта"
                    />
                </Form.Item>

                <Form.Item>
                    <Flex gap="middle" justify="end">
                        <Button onClick={onClose}>
                            Отмена
                        </Button>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            Создать
                        </Button>
                    </Flex>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default CreateProjectModal;
